export function invalidatesOn<T>({
  success = [],
  error = [],
}: {
  success: T[];
  error: T[];
}): (_: unknown, err: unknown) => T[] {
  return (_: unknown, err: unknown) => (err ? error : success);
}
